import { render, staticRenderFns } from "./BasePill.vue?vue&type=template&id=06928eef&scoped=true&"
import script from "./BasePill.vue?vue&type=script&lang=js&"
export * from "./BasePill.vue?vue&type=script&lang=js&"
import style0 from "./BasePill.vue?vue&type=style&index=0&id=06928eef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06928eef",
  null
  
)

export default component.exports